/** @module @smartrecruiters/openapi-schemas-validator */
module.exports = require('./lib/SchemaValidator');